"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.useInitializeContext = exports.useSwitchContext = void 0;
var react_1 = require("react");
var useControllableValue_1 = __importDefault(require("../../../helpers/hook/useControllableValue"));
var SwitchContext = react_1.createContext(undefined);
var useSwitchContext = function () {
    var context = react_1.useContext(SwitchContext);
    if (!context) {
        throw new Error('useSwitchContext must be inside a SwitchBase');
    }
    return context;
};
exports.useSwitchContext = useSwitchContext;
var useInitializeContext = function (_a) {
    var ariaId = _a.ariaId, checked = _a.checked, onChanging = _a.onChanging, onChange = _a.onChange;
    var _b = useControllableValue_1["default"]({
        value: !!checked,
        onChanging: onChanging,
        onChange: onChange
    }), checkedFromState = _b[0], changeChecked = _b[1];
    return { ariaId: ariaId, checked: checkedFromState, changeChecked: changeChecked };
};
exports.useInitializeContext = useInitializeContext;
exports["default"] = SwitchContext;
//# sourceMappingURL=SwitchContext.js.map